(function() {
  'use strict';

  var script = document.currentScript;
  var activeCurrency = script
    ? script.getAttribute('data-active-currency')
    : '';

  if (
    !activeCurrency &&
    window.Shopify &&
    window.Shopify.currency
  ) {
    activeCurrency = window.Shopify.currency.active;
  }

  if (String(activeCurrency || '').toUpperCase() !== 'EUR') {
    return;
  }

  var skippedElements = {
    NOSCRIPT: true,
    SCRIPT: true,
    STYLE: true,
    TEXTAREA: true
  };
  var europeanAmount =
    '(?:\\d{1,3}(?:\\.\\d{3})+(?:,\\d{1,2})?|\\d+,\\d{1,2})';
  var euroBeforeAmount = new RegExp(
    '(€)([\\s\\u00a0\\u202f]*)(' + europeanAmount + ')(?!\\d)',
    'g'
  );
  var euroAfterAmount = new RegExp(
    '(' + europeanAmount + ')([\\s\\u00a0\\u202f]*)(€)',
    'g'
  );

  function addThousandsSeparators(value) {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatEuropeanAmount(value) {
    var parts = value.split(',');
    var whole = parts[0].replace(/\./g, '');
    var decimal = parts.length > 1 ? '.' + parts[1] : '';

    return addThousandsSeparators(whole) + decimal;
  }

  function normalizeEuroPrices(value) {
    return String(value)
      .replace(euroBeforeAmount, function(match, symbol, spacing, amount) {
        return symbol + spacing + formatEuropeanAmount(amount);
      })
      .replace(euroAfterAmount, function(match, amount, spacing, symbol) {
        return formatEuropeanAmount(amount) + spacing + symbol;
      });
  }

  function normalizeTextNode(node) {
    var parent = node.parentNode;

    if (parent && skippedElements[parent.nodeName]) {
      return;
    }

    var normalized = normalizeEuroPrices(node.nodeValue);

    if (normalized !== node.nodeValue) {
      node.nodeValue = normalized;
    }
  }

  function normalizeTree(root) {
    if (!root) {
      return;
    }

    if (root.nodeType === 3) {
      normalizeTextNode(root);
      return;
    }

    if (root.nodeType === 1 && skippedElements[root.nodeName]) {
      return;
    }

    if (
      root.nodeType !== 1 &&
      root.nodeType !== 9 &&
      root.nodeType !== 11
    ) {
      return;
    }

    var walker = document.createTreeWalker(root, 4, null, false);
    var textNode;

    while ((textNode = walker.nextNode())) {
      normalizeTextNode(textNode);
    }
  }

  function patchShopifyMoneyFormatter() {
    if (
      !window.Shopify ||
      typeof window.Shopify.formatMoney !== 'function' ||
      window.Shopify.formatMoney.soshiotsukiEurEnglishFormat
    ) {
      return;
    }

    var originalFormatMoney = window.Shopify.formatMoney;
    var wrappedFormatMoney = function() {
      return normalizeEuroPrices(originalFormatMoney.apply(this, arguments));
    };

    wrappedFormatMoney.soshiotsukiEurEnglishFormat = true;
    window.Shopify.formatMoney = wrappedFormatMoney;
  }

  function start() {
    patchShopifyMoneyFormatter();
    normalizeTree(document.body);

    if (!document.body || typeof window.MutationObserver !== 'function') {
      return;
    }

    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData') {
          normalizeTextNode(mutation.target);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, normalizeTree);
      });
    }).observe(document.body, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
